(() => {
  const root = document.querySelector('[data-tbh-pr-box]');
  if (!(root instanceof HTMLElement)) return;

  const variantId = Number(root.dataset.variantId);
  if (!Number.isSafeInteger(variantId)) return;

  let redirecting = false;

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const updateGiftQuantity = async (lineKey) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 1 }),
    });
    if (!response.ok) throw new Error('Unable to normalize PR Box quantity');
  };

  const removeGift = async (lineKey) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });
    if (!response.ok) throw new Error('Unable to remove standalone PR Box');
  };

  const addGift = async () => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _tbh_pr_box: 'Launch promotion' } }],
      }),
    });
    if (!response.ok) throw new Error('Unable to add PR Box');
  };

  const ensureGift = async () => {
    const cart = await fetchCart();
    const merchandise = cart.items.filter((item) => item.variant_id !== variantId);
    const gift = cart.items.find((item) => item.variant_id === variantId);

    if (merchandise.length === 0) {
      if (gift) await removeGift(gift.key);
      return false;
    }

    if (!gift) await addGift();
    if (gift && gift.quantity !== 1) await updateGiftQuantity(gift.key);
    return true;
  };

  document.addEventListener(
    'click',
    async (event) => {
      const target = event.target;
      if (!(target instanceof Element) || redirecting) return;

      const checkout = target.closest('[name="checkout"]');
      if (!(checkout instanceof HTMLElement)) return;

      event.preventDefault();
      redirecting = true;
      checkout.setAttribute('aria-busy', 'true');

      let canCheckout = false;

      try {
        canCheckout = await ensureGift();
      } catch (error) {
        console.error('PR Box promotion:', error);
      } finally {
        window.location.assign(canCheckout ? '/checkout' : '/cart');
      }
    },
    true
  );
})();
